// extracted by mini-css-extract-plugin
module.exports = {"avuStickyTopSection":"_3qC9W8"};